module.exports = __webpack_public_path__ + "img/icon2.f8510d18.gif";